module.exports = __webpack_public_path__ + "static/bob-goff.4a21d252.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/bob-goff.jpg
// module id = 1299
// module chunks = 168707334958949